@if (organization(); as organization) {
  <div class="space-y-6">
    <div
      class="rounded-[20px] border border-slate-200 bg-white p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04)] md:p-5"
    >
      <div class="flex items-center gap-4">
        <div
          class="organization-details-icon flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-50 text-teal-600"
        >
          <i class="pi pi-building"></i>
        </div>

        <div class="min-w-0">
          <p class="mb-1 text-base font-medium text-slate-500">
            {{ TRANSLATION_PATH + 'fields.name' | translate }}
          </p>
          <h2
            class="organization-details-title m-0 truncate font-semibold leading-tight tracking-[-0.02em] text-slate-900"
            data-testid="organization-details-name"
          >
            {{ organization.name | fallbackValue }}
          </h2>

          <div
            class="organization-details-badge mt-3 inline-flex items-center justify-center rounded-[20px] px-4 py-2 text-[1.4rem] font-medium"
          >
            {{ organization.legalForm | fallbackValue }}
          </div>
        </div>
      </div>
    </div>

    <lib-section
      [title]="TRANSLATION_PATH + 'sections.companyData' | translate"
      icon="pi pi-building"
    >
      <ng-container content>
        <div class="grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-2">
          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.cui' | translate }}
            </p>
            <p
              class="organization-details-value m-0 font-medium leading-tight text-slate-900"
              data-testid="organization-details-cui"
            >
              {{ organization.cui | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.specialCui' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.specialCui | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.tradeRegisterNumber' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.tradeRegisterNumber | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.shareCapital' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.shareCapital | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.name' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.name | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.caenCode' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.caenCode | fallbackValue }}
            </p>
          </div>

          <div class="md:col-span-2">
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.legalForm' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.legalForm | fallbackValue }}
            </p>
          </div>
        </div>
      </ng-container>
    </lib-section>

    <lib-section
      [title]="TRANSLATION_PATH + 'sections.headquarters' | translate"
      icon="pi pi-map-marker"
    >
      <ng-container content>
        <div class="grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-2">
          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.country' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.country | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.city' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.city | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.addressDetails' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.addressDetails | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.postalCode' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.postalCode | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.name' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.name | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.county' | translate }}
            </p>
            <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
              {{ organization.county | fallbackValue }}
            </p>
          </div>
        </div>
      </ng-container>
    </lib-section>

    <lib-section [title]="TRANSLATION_PATH + 'sections.contact' | translate" icon="pi pi-envelope">
      <ng-container content>
        <div class="grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-2">
          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.email' | translate }}
            </p>
            <p
              class="organization-details-value m-0 break-all font-medium leading-tight text-slate-900"
            >
              {{ organization.email | fallbackValue }}
            </p>
          </div>

          <div>
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.phone' | translate }}
            </p>
            <p
              class="organization-details-value m-0 font-medium leading-tight text-slate-900"
              data-testid="organization-details-phone"
            >
              {{ organization.phone | fallbackValue }}
            </p>
          </div>

          <div class="md:col-span-2">
            <p class="mb-1 text-base font-medium text-slate-500">
              {{ TRANSLATION_PATH + 'fields.website' | translate }}
            </p>
            @if (organization.website) {
              <a
                class="organization-details-link organization-details-value font-medium leading-tight underline"
                [href]="organization.website"
                target="_blank"
                rel="noreferrer"
              >
                {{ organization.website }}
              </a>
            } @else {
              <p class="organization-details-value m-0 font-medium leading-tight text-slate-900">
                {{ organization.website | fallbackValue }}
              </p>
            }
          </div>
        </div>
      </ng-container>
    </lib-section>
  </div>
}
